import { Link, useLocation } from "react-router-dom"
import { useEffect, useState } from "react"
import "./adminSidebar.css"

export function AdminSidebar({ sidebarDisplay }) {
    const location = useLocation()
    
    const [headerSticky, setHeaderSticky] = useState(false)

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 1) {
                setHeaderSticky(true)
            } else {
                setHeaderSticky(false)
            }
        })
    }, [])

    const sidebarLinks = {
        Dashboard: {
            path: "/admin",
            keyword: "dashboard"
        },
        Products: {
            path: "/admin/products",
            keyword: "products"
        },
        Orders: {
            path: "/admin/orders",
            keyword: "orders"
        },
        Customers: {
            path: "/admin/customers",
            keyword: "customers"
        }
    }

    const sidebarLinksKeys = Object.keys(sidebarLinks)

    return (
        <div className={`admin-sidebar d-flex flex-column px-4 bg-white ${sidebarDisplay ? "on" : ""}`} style={{ transition: "0.3s" }}>
            <div className={`d-flex flex-column gap-2 position-relative ${headerSticky ? "on" : ""}`}>
                {
                    sidebarLinksKeys.map((e, i) => (
                        <Link
                            key={i}
                            to={sidebarLinks[e].path}
                            className={
                                `d-flex align-items-center gap-3 py-2 rounded-1 
                                ${location.pathname === sidebarLinks[e].path ||
                                location.pathname.includes(sidebarLinks[e].keyword) ? "on" : ""}`}>
                                    <div className={`${e.toLowerCase()}-icon position-absolute`}></div>
                                    <div>{e}</div>
                        </Link>
                    ))
                }
                <div className={`custom-btn default rounded-1 d-flex align-items-center gap-3 justify-content-center position-absolute ${headerSticky ? "on" : ""}`}>
                    <div className="logout-icon position-absolute"></div>
                    <div>Logout</div>
                </div>
            </div>
        </div>
    )
}